/**
 * Shared persistence layer for the Normal / Deep analysis-mode toggle.
 *
 * Single source of truth so every submit path (composer textarea,
 * suggested-question cards, reconnect retries, etc.) sends the mode
 * the user actually has selected in the UI — not a hardcoded default.
 *
 * Stored as a plain string in ``localStorage`` (per-browser); reads
 * are defensive — unknown / missing values fall back to ``"normal"``.
 */

export type AnalysisMode = 'normal' | 'deep';

const STORAGE_KEY = 'financeBotV2.analysisMode';

export const readPersistedAnalysisMode = (): AnalysisMode => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw === 'deep' || raw === 'normal') return raw;
  } catch {
    /* sandboxed / disabled storage — fall through */
  }
  return 'normal';
};

export const writePersistedAnalysisMode = (mode: AnalysisMode): void => {
  try {
    window.localStorage.setItem(STORAGE_KEY, mode);
  } catch {
    /* sandboxed / disabled storage — silently skip */
  }
};
